import * as core from '../../../../../../../core'

import { query } from './delete-external-institution.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.external-institutions.delete-institution',
    description: 'Delete External Institution',
    name: 'Delete External Institution',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
